import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import moment from "moment"

export interface AdvanceSearch {
    messageVisibility: boolean,
    searchValue: string | null,
    // fromDate: Date | string,
    fromDate: any,
    // toDate: Date | string,
    toDate: any,
    searchResult: any,
    errorMessage: Error | null,
}


const initialState: AdvanceSearch = {
    messageVisibility: false,
    searchValue: null,
    fromDate: moment(new Date()).subtract(7, 'days').toDate(),
    toDate: new Date(),
    searchResult: null,
    errorMessage: null
}


const AdvanceSearchSlice = createSlice({
    name: "advSearch",
    initialState: initialState,
    reducers: {
        updateMessage: (state) => {
            state.messageVisibility = !state.messageVisibility;
        },
        updateSearchValue: (state, action: PayloadAction) => {
            state.searchResult = action.payload
        },
        setFromDate: (state, action: PayloadAction | any) => {
            // store.fromDate = moment(action.payload).subtract(7, 'days').toDate()
            state.fromDate = action.payload
        },
        setToDate: (state, action: PayloadAction) => {
            state.toDate = action.payload
        }
    }
})
export const { updateMessage, updateSearchValue, setFromDate, setToDate } = AdvanceSearchSlice.actions
export default AdvanceSearchSlice.reducer